export function getDsbLocalStorageKey(locale) {
  let version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v1';
  return `dsb-core_${locale}_${version}`;
}